import { render, staticRenderFns } from "./PeoDashboard.vue?vue&type=template&id=2d765bcf"
import script from "./PeoDashboard.vue?vue&type=script&lang=js"
export * from "./PeoDashboard.vue?vue&type=script&lang=js"
import style0 from "./PeoDashboard.vue?vue&type=style&index=0&id=2d765bcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports